/** Namespace `shopIntegrationCards` — PLAT-2026-107, bản gốc tiếng Việt. */
export const shopIntegrationCards = {
  title: "Hiển thị tích hợp cho khách Bube Shop",
  subtitle:
    "Thẻ nào bật ở đây thì trang « Tích hợp » của MỌI cửa hàng bube-shop mới hiện thẻ đó. Tắt chỉ ngừng mở kết nối mới — kết nối cửa hàng đã có vẫn chạy.",
  loadFailed: "Không đọc được thẻ tích hợp của bube-shop.",
  saveFailed: "Không đổi được thẻ tích hợp.",
  storageNotReady:
    "CSDL bube-shop chưa có cột `integration_apps.visible` (migration PLAT-2026-107 chưa chạy). Mọi thẻ đang ẩn và chưa bật được.",
  shown: "Đang hiện",
  hidden: "Đang ẩn",
  comingSoon: "Sắp ra mắt",
  defaultState: "mặc định, chưa ai chỉnh",
  changedAt: "đổi lúc {at}",
  changedBy: " bởi {by}",
  show: "Hiện cho cửa hàng",
  hide: "Ẩn khỏi cửa hàng",
  confirmShow: "Xác nhận HIỆN « {name} » cho mọi cửa hàng",
  confirmHide: "Xác nhận ẨN « {name} »",
  saving: "Đang đổi…",
  cancel: "Huỷ",
  readOnly: "Bạn chỉ có quyền xem. Bật / tắt thẻ cần vai chủ (`hq.integrations.write`).",
} as const;
